import { IcoChevronLeft16, IcoChevronRight16 } from '@onefootprint/icons';
import { IconButton } from '@onefootprint/ui';
import { Fragment, type ReactNode, type RefObject, useRef, useState } from 'react';
import { useResizeObserver } from 'usehooks-ts';
import SourceTile, { type SourceTileProps } from './source-tile';
import type { ComparisonImage, ComparisonSelection, SlotIndex } from './types';
type ImageCarouselProps = {
  images: ComparisonImage[];
  selection: ComparisonSelection;
  activeSlot: SlotIndex;
  onSelect: (id: string) => void;
  renderSource?: (props: SourceTileProps) => ReactNode;
};
const ImageCarousel = ({
  images,
  selection,
  activeSlot,
  onSelect,
  renderSource = props => <SourceTile {...props} />
}: ImageCarouselProps) => {
  const [requestedPage, setPage] = useState(0);
  const carousel = useRef<HTMLElement>(null) as RefObject<HTMLElement>;
  const {
    width = 0
  } = useResizeObserver({
    ref: carousel,
    box: 'border-box'
  });
  const pageSize = width >= 640 ? 3 : 1;
  const lastPage = Math.max(0, Math.ceil(images.length / pageSize) - 1);
  const page = Math.min(requestedPage, lastPage);
  return <nav ref={carousel} aria-label="Image carousel" className="flex items-center gap-2 border-t border-tertiary px-3 py-3">
      {lastPage > 0 && <IconButton icon={IcoChevronLeft16} size="compact" aria-label="Previous images" disabled={page === 0} onClick={() => setPage(page - 1)} />}
      <div className="grid min-w-0 flex-1 gap-2" style={{
      gridTemplateColumns: `repeat(${pageSize}, minmax(0, 1fr))`
    }}>
        {images.slice(page * pageSize, (page + 1) * pageSize).map(image => <Fragment key={image.id}>
            {renderSource({
          image,
          selectedSlot: selection.indexOf(image.id),
          activeSlot,
          onSelect: () => onSelect(image.id)
        })}
          </Fragment>)}
      </div>
      {lastPage > 0 && <IconButton icon={IcoChevronRight16} size="compact" aria-label="Next images" disabled={page === lastPage} onClick={() => setPage(page + 1)} />}
    </nav>;
};
export default ImageCarousel;